import { req } from './axiosFun';

// 查询位置列表
export const listGtye=(query)=> {
  return req(
    "post",
    "/api/admin/gtye/list",
    query
  )
}

// 查询位置详细
export const getGtye=(id)=> {
  return req(
    'get',
    '/api/admin/gtye/',
    id
  )
}

// 新增位置
export const saveGtye=(data)=> {
  return req(
    'post',
    '/api/admin/gtye/save',
    data
  )
}

// 新增位置
export const addGtye=(data)=> {
  return req(
    'post',
    '/api/admin/gtye',
    data
  )
}

// 修改位置
export const updateGtye=(data)=> {
  return req(
    'put',
    '/api/admin/gtye',
    data
  )
}

// 删除位置
export const delGtye=(id)=> {
  return req(
    'post',
    '/api/admin/gtye/deleteGtye',
    id
  )
}



// WEBPACK FOOTER //
// ./src/api/gtye.js